import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

const KEY_CODE_ESC = 27;
const DELAY_ON_CHANGE_BY = 200;  // in ms
const MASK_VALUE_CHANGE_DELTA = 800;  // in ms

const SearchField = createReactClass({
  propTypes: {
    onChange: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  },

  getDefaultProps() {
    return {
      autoFocus: true,
      placeholder: 'Search Icons',
      value: '',
    };
  },

  getInitialState() {
    return {
      value: this.props.value,
      lastChange: 0,
    };
  },

  componentDidMount() {
    this.debouncedOnChange = debounce((...args) => {
      this.props.onChange(...args);
    }, DELAY_ON_CHANGE_BY);

    if (this.props.autoFocus) {
      this.refs.searchQuery.focus();
    }
  },

  componentWillReceiveProps(nextProps) {
    if (Date.now() - this.state.lastChange > MASK_VALUE_CHANGE_DELTA) {
      this.setState({
        value: nextProps.value,
      });
    }
  },

  handleSearchQueryChanged(event) {
    const value = this.refs.searchQuery.value;

    this.debouncedOnChange(value);

    this.setState({
      value,
      lastChange: Date.now(),
    });
  },

  handleSearchQueryKeyDown(event) {
    if (event.keyCode === KEY_CODE_ESC) {
      this.clearValue();
    }
  },

  handleClearValueClicked(event) {
    event.preventDefault();

    this.clearValue();
  },

  clearValue() {
    this.setState({value: ''}, () => {
      this.debouncedOnChange(this.state.value);

      this.refs.searchQuery.focus();
    });
  },

  render() {
    let controlIndicator = <i className="ficon ficon-search"></i>;

    if (this.state.value.length > 0) {
      controlIndicator = <a href="#" onClick={this.handleClearValueClicked} className="link-dashed-none"><i className="ficon ficon-times"></i></a>;
    }

    return (
      <div className="has-icon">
        <input
          ref="searchQuery"
          type="text"
          name="q"
          className="form-control form-control-lg input-search"
          autoComplete="off"
          placeholder={this.props.placeholder}
          value={this.state.value}
          onChange={this.handleSearchQueryChanged}
          onKeyDown={this.handleSearchQueryKeyDown}
        />
        <div className="input-icon form-control-lg">
          {controlIndicator}
        </div>
      </div>
    );
  },
});

export default SearchField;



// WEBPACK FOOTER //
// ./app/javascript/components/SearchField.js